export enum AuthorizationType {
  NO_AUTH = 'no_auth',
  BASIC = 'basic_auth',
  OAUTH_2 = 'oauth_2',
}
